import {fromJS} from "immutable";
import {
  SET_SELECTION, 
  CLEAR_SELECTION,
  TOGGLE_SELECTION,
  } from "../actions/SelectionActions";
import {
  REMOVED_PRODUCT
} from "../actions/InventoryApiActions";

const initialState = fromJS({
  selection: "",
  context: ""
})

export default function(state = initialState, action) {
  switch(action.type) {
    case SET_SELECTION:
      return setSelection(state, action.context, action.id);

    case TOGGLE_SELECTION:
      return toggleSelection(state, action.context, action.id);

    case CLEAR_SELECTION:
      return clearSelection(state, action.context);

    case REMOVED_PRODUCT:
      return clearSelectionIfMatch(state, "products", action.code);

    default:
      return state;
  }
}

function clearSelectionIfMatch(state, condContext, condSelection) {
  if (state.get("context") === condContext && state.get("selection") === condSelection) {
    return clearSelection(state, state.get("context"));
  }
  return state;
}

function clearSelection(state, currentContext) {
  if (state.get("context") !== currentContext) return state;
  return setSelection(state, "");
}

function setSelection(state, context, id="") {
  return state.set("selection", id)
              .set("context", context);
}

function toggleSelection(state, currentContext, id="") {
  if (state.get("context") !== currentContext) return state;
  if (state.get("selection", "") === id) return clearSelection(state, currentContext);
  return setSelection(state, currentContext, id);
}

export function getSelection(state, context) {
  if (state.get("context", "") !== context) return "";
  return state.get("selection", "");
}